import apis from "../../core/apis.js";

class RatingResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  daily(options) {
    return this.$resource(apis.rating + "/daily").get(options);
  }

  weekly(options) {
    return this.$resource(apis.rating + "/weekly").get(options);
  }

  monthly(options) {
    return this.$resource(apis.rating + "/monthly").get(options);
  }
}

export default RatingResource;



// WEBPACK FOOTER //
// ./src/resources/rating/rating.resource.js